module.exports = __webpack_public_path__ + "media/dashboard/assets/images/controller-record-white-0887e57f1a0ff8454d9a74856f96254c.svg";